import { Box, Stack } from '@mui/material';
import { ReactElement } from 'react';
import { theme } from '../Mui/Theme';

interface SignInLayoutProps {
    children: ReactElement | ReactElement[];
}

export const SignInLayout: React.FC<SignInLayoutProps> = ({ children }) => {
    return (
        <Box
            width="100%"
            height="100%"
            sx={{
                backgroundColor: theme.palette.primary.light,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Stack
                spacing={2}
                minWidth="50%"
                minHeight="60%"
                style={{
                    background: theme.palette.primary.main,
                    borderRadius: '30px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '30px',
                }}
            >
                {children}
            </Stack>
        </Box>
    );
};
